import React, { useEffect, useReducer, useState } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { useNavigate } from "react-router-dom";
import { CardFooter } from "react-bootstrap";
import Select from "react-select";
import ModalInfo from "../../components/modal/modalInfo.jsx";
import { optionSelector, planTrainingNewMain } from "../../config/apiSPA.js";

function reducer(state, action) {
  switch (action.type) {
    case "trainingId": {
      return { ...state, trainingId: action.value };
    }
    case "locationId": {
      return { ...state, locationId: action.value };
    }
    case "institutionId": {
      return { ...state, institutionId: action.value };
    }
    case "instructorId": {
      return { ...state, instructorId: action.value };
    }
    case "startDate": {
      return { ...state, startDate: action.value };
    }
    case "endDate": {
      return { ...state, endDate: action.value };
    }
    case "remark": {
      return { ...state, remark: action.value };
    }
  }
}
const initialValue = {
  trainingId: "",
  locationId: "",
  institutionId: "",
  instructorId: "",
  startDate: "",
  endDate: "",
  remark: "",
};

function PlanTrainingNewReport() {
  const [eventData, eventDataDispatch] = useReducer(reducer, initialValue);
  const [listTrainingTitle, setListTrainingTitle] = useState([]);
  const [listLocation, setListLocation] = useState([]);
  const [listInstitution, setListInstitution] = useState([]);
  const [listInstructor, setListInstructor] = useState([]);
  const [invalid, setInvalid] = useState({ errors: {} });
  const [modalInfo, setModalInfo] = useState({ show: false, title: "Failed", text: "Terjadi kesalahan" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleNextButton = async () => {
    try {
      setLoading(true);
      const res = await planTrainingNewMain(eventData);
      navigate("/training/plan/detail/" + res.data.id);
      setLoading(false);
    } catch (error) {
      setModalInfo({ show: true, title: "Failed", text: `Error message: ${error.message}` });
      setLoading(false);
    }
  };
  useEffect(() => {
    optionSelector(`/trainingTitle`).then((res) => setListTrainingTitle(res));
    optionSelector(`/location`).then((res) => setListLocation(res));
    optionSelector(`/institution`).then((res) => setListInstitution(res));
    optionSelector(`/instructor`).then((res) => setListInstructor(res));
  }, []);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">TRAINING</a>
                  </li>
                  <li className="breadcrumb-item active">NEW</li>
                </ul>

                <h1 className="page-header">Create New Plan Training</h1>

                <hr className="mb-4" />

                {/* ------------------------------------------------------CONTENT------------------------------------------------------- */}
                <div id="formControls" className="mb-5">
                  {/* <h4>Suggestions</h4>
                  <p></p> */}
                  <Card>
                    <CardBody className="pb-2">
                      <form>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="form-group mb-3">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Training Title
                              </label>
                              <Select options={listTrainingTitle} onChange={(e) => eventDataDispatch({ type: "trainingId", value: e.value })} classNamePrefix="react-select" />
                              {invalid.errors.trainingId ? <p className="text-danger">{invalid.errors.trainingId}</p> : ""}
                            </div>
                            <div className="form-group mb-3">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Location
                              </label>
                              <Select options={listLocation} onChange={(e) => eventDataDispatch({ type: "locationId", value: e.value })} classNamePrefix="react-select" />
                              {invalid.errors.locationId ? <p className="text-danger">{invalid.errors.locationId}</p> : ""}
                            </div>
                            <div className="form-group mb-3">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Institution
                              </label>
                              <Select options={listInstitution} onChange={(e) => eventDataDispatch({ type: "institutionId", value: e.value })} classNamePrefix="react-select" />
                              {invalid.errors.institutionId ? <p className="text-danger">{invalid.errors.institutionId}</p> : ""}
                            </div>
                            <div className="form-group mb-3 ">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Instructor
                              </label>
                              <Select options={listInstructor} onChange={(e) => eventDataDispatch({ type: "instructorId", value: e.value })} classNamePrefix="react-select" />
                              {invalid.errors.instructorId ? <p className="text-danger">{invalid.errors.instructorId}</p> : ""}
                            </div>
                            <div className="form-group mb-3 ">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Start Date
                              </label>
                              <input type="date" onChange={(e) => eventDataDispatch({ type: "startDate", value: e.target.value })} className="form-control" />
                              {invalid.errors.startDate ? <p className="text-danger">{invalid.errors.startDate}</p> : ""}
                            </div>
                            <div className="form-group mb-3 ">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                End Date
                              </label>
                              <input type="date" onChange={(e) => eventDataDispatch({ type: "endDate", value: e.target.value })} className="form-control" />
                              {invalid.errors.endDate ? <p className="text-danger">{invalid.errors.endDate}</p> : ""}
                            </div>
                            <div className="form-group mb-3 ">
                              <label className="form-label" htmlFor="exampleFormControlInput1">
                                Remark
                              </label>
                              <textarea onChange={(e) => eventDataDispatch({ type: "remark", value: e.target.value })} className="form-control" />
                            </div>
                          </div>
                        </div>
                      </form>
                    </CardBody>
                    <CardFooter>
                      {loading ? (
                        <div className="spinner-border"></div>
                      ) : (
                        <button onClick={() => handleNextButton()} type="submit" className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">
                          NEXT
                        </button>
                      )}
                    </CardFooter>
                  </Card>
                </div>
                {/* ------------------------------------------------------END CONTENT------------------------------------------------------- */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalInfo show={modalInfo.show} clicked={() => setModalInfo((a) => ({ ...a, show: false }))} theme={"danger"} title={modalInfo.title} text={modalInfo.text} onHide={() => setModalInfo((a) => ({ ...a, show: false }))} />
    </>
  );
}

export default PlanTrainingNewReport;
